import React from "react";

import DropDownList from "@stubhub/react-dropdown-list";

import "./event-sorter.css";

const EventSorter = ({ onSelection, selected = "date", items }) => {
  return (
    <div className="EventListPanel__Sorter">
      <DropDownList
        items={items}
        onSelection={onSelection}
        selected={selected}
        className="EventSorter"
        displayClassName="EventSorter__Display"
        closeable={false}
      />
    </div>
  );
};

export default EventSorter;
